import createIcon from '../../createIcon';

/**
 * @component @name Bungalow
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMDAwMiAzTDQuMjAwMiAxNS41TDUuOTAwMiAxNi41Nkw3LjAwMDIgMTQuOFYyMUgxMS4wMDAyVjE2SDEzLjAwMDJWMjFIMTcuMDAwMlYxNC43OUwxOC4xMDAyIDE2LjU2TDE5LjgwMDIgMTUuNUwxMi4wMDAyIDNaTTEzLjAwMDIgMTRIMTEuMDAwMlYxMkgxMy4wMDAyVjE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Bungalow = createIcon('Bungalow', [
  [
    'path',
    {
      d: 'M12.0002 3L4.2002 15.5L5.9002 16.56L7.0002 14.8V21H11.0002V16H13.0002V21H17.0002V14.79L18.1002 16.56L19.8002 15.5L12.0002 3ZM13.0002 14H11.0002V12H13.0002V14Z',
      key: '88cx0j',
    },
  ],
]);

export default Bungalow;
